var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1707481840"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1707481841"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 33605",
    x: 2.5,
    y: 2.5,
    width: 15,
    height: 15,
    rx: 4.16667,
    stroke: "white",
    strokeWidth: 1.66667
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 752",
    d: "M8.33333 6.25H7.08333C6.6231 6.25 6.25 6.6231 6.25 7.08333V8.33333",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 753",
    d: "M13.75 8.33333L13.75 7.08333C13.75 6.6231 13.3769 6.25 12.9167 6.25L11.6667 6.25",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 754",
    d: "M11.6667 13.75L12.9167 13.75C13.3769 13.75 13.75 13.3769 13.75 12.9167L13.75 11.6667",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 755",
    d: "M6.25 11.6667L6.25 12.9167C6.25 13.3769 6.6231 13.75 7.08333 13.75L8.33333 13.75",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScan);
export default __webpack_public_path__ + "static/media/Scan.5a595bf3ccd3fb075e4fb25cd8491665.svg";
export { ForwardRef as ReactComponent };